import { Box, Typography } from '@wishket/design-system';
import { twMerge } from 'tailwind-merge';

interface FilterChipProps {
  label: string;
  onClick?: () => void;
  isActive: boolean;
}

const FilterChip = ({ label, onClick, isActive }: FilterChipProps) => {
  return (
    <Box
      className={twMerge(
        'cursor-pointer rounded-full border px-[15px] py-1.5',
        isActive
          ? 'border-2 border-primary-500 bg-primary-10 px-3.5 py-[5px]'
          : 'border-w-gray-200 hover:border-primary-500'
      )}
      onClick={onClick}
    >
      <Typography
        variant="body1"
        className={isActive ? 'text-primary-500' : 'text-w-gray-900'}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default FilterChip;
